var _style, _g, _style2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnssvgjs: "http://svgjs.com/svgjs",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 182 182",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Circle_T-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #2a7796 } \n\t\t.s1 { fill: #f3f3f5 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1004"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1002"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath1001",
    className: "s0",
    d: "m85.8 5.5c-42.6 2.6-77.2 37.3-79.8 79.8-3.1 49.7 36.3 90.9 85.3 90.9 47.1 0 85.4-38.3 85.4-85.5 0-49-41.3-88.3-90.9-85.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath1000",
    className: "s1",
    d: "m147.1 71.4c-2 2.2-5 3.5-8.7 3.5h-35.1v55.4c0 3.6-1.2 6.6-3.5 8.5q-3.4 3.1-8.3 3.1c-3.1 0-5.9-1-8.2-2.9-2.3-2.1-3.5-5.1-3.5-8.7v-55.4h-35.3c-3.6 0-6.6-1.3-8.7-3.5q-3.1-3.4-3.1-8.4 0-4.9 3.1-8.3c2.1-2.3 5.1-3.5 8.7-3.5h93.9c3.7 0 6.7 1.2 8.7 3.5q3.2 3.4 3.2 8.3 0 5-3.2 8.4z"
  })))))), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", null, "@media (prefers-color-scheme: light) { :root { filter: none; } }\n")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c75c65848c91169875553d576da58d68.svg";
export { ForwardRef as ReactComponent };